export default function loggableProp(bodyProp: string) {
    const loggable = bodyProp.substring(0, 1) + 'xxxx' + bodyProp.slice(-2);;
    return `${loggable}(${bodyProp.length})`;
}
